"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var QueriesStore_1 = require("stores/QueriesStore");
var use_stores_1 = require("hooks/use-stores");
var UserStore_1 = require("stores/UserStore");
var Radios_1 = __importDefault(require("components/core/inputs/Radios"));
var InfoRow_1 = __importDefault(require("components/core/common/InfoRow"));
var TextInput_1 = __importDefault(require("components/core/inputs/TextInput"));
var api_1 = __importDefault(require("api"));
var Notification_1 = require("../../../../core/Notification");
var use_notification_1 = require("../../../../../hooks/use-notification");
var dayjs_1 = __importDefault(require("dayjs"));
var toBoolean = function (input) { return input === "true"; };
var PODQueryStage2 = function (_a) {
    var data = _a.data;
    var _b = use_stores_1.useStores(), userStore = _b.userStore, queriesStore = _b.queriesStore;
    var notification = use_notification_1.useNotification();
    var timeout = react_1.useRef(null);
    var changeHandler = function (e) {
        var _a;
        var value = e.currentTarget.value;
        if (value === "true" || value === "false")
            value = toBoolean(value);
        api_1.default.patchQuery(data.id, (_a = {},
            _a[e.currentTarget.name] = value,
            _a))
            .then(function (response) {
            queriesStore.editDataItem(response.data);
            notification({
                variant: Notification_1.NotificationVariants.SUCCESS,
                message: "Query updated"
            });
        }, function (error) {
            notification({
                variant: Notification_1.NotificationVariants.ERROR,
                message: "Error updating query"
            });
        });
    };
    var keyHandler = function (e) {
        var name = e.currentTarget.name;
        var value = e.currentTarget.value;
        if (timeout.current !== null)
            clearTimeout(timeout.current);
        timeout.current = setTimeout(function () {
            var _a;
            api_1.default.patchQuery(data.id, (_a = {},
                _a[name] = value,
                _a))
                .then(function (response) {
                queriesStore.editDataItem(response.data);
                notification({
                    variant: Notification_1.NotificationVariants.SUCCESS,
                    message: "Query successfully updated"
                });
            }, function (error) {
                notification({
                    variant: Notification_1.NotificationVariants.ERROR,
                    message: "Error updating query"
                });
            });
        }, 500);
    };
    return (react_1.default.createElement("div", { className: "pod-query-stage-2" },
        react_1.default.createElement("div", { className: "flex flex-row" },
            react_1.default.createElement("div", { className: "half" },
                data.status === QueriesStore_1.QueryStatus.ACTIVE &&
                    data.queryStage.stage === 2 &&
                    userStore.hasPermission(UserStore_1.Permissions.STAGE_2) ?
                    react_1.default.createElement(Radios_1.default, { altLabel: "I have attached the POD to stage 1", name: "hasPOD", value: data.podQuery.hasPOD || false, onChange: changeHandler, options: [
                            { value: true, label: "Yes" },
                            { value: false, label: "No" }
                        ] })
                    :
                        react_1.default.createElement(InfoRow_1.default, { label: "I have attached the POD to stage 1", value: data.podQuery.hasPOD ? "Yes" : "No" }),
                data.status === QueriesStore_1.QueryStatus.ACTIVE &&
                    data.queryStage.stage === 2 &&
                    userStore.hasPermission(UserStore_1.Permissions.STAGE_2) ?
                    react_1.default.createElement(Radios_1.default, { altLabel: "The POD is clean - Credit Refused, copy attached to stage 1", name: "hasRefusedCleanPOD", value: data.podQuery.hasRefusedCleanPOD || false, onChange: changeHandler, options: [
                            { value: true, label: "Yes" },
                            { value: false, label: "No" }
                        ] })
                    :
                        react_1.default.createElement(InfoRow_1.default, { label: "The POD is clean - Credit Refused, copy attached to stage 1", value: data.podQuery.hasRefusedCleanPOD ? "Yes" : "No" }),
                data.status === QueriesStore_1.QueryStatus.ACTIVE &&
                    data.queryStage.stage === 2 &&
                    userStore.hasPermission(UserStore_1.Permissions.STAGE_2) ?
                    react_1.default.createElement(Radios_1.default, { altLabel: "Please raise Dummy Order", name: "dummyOrderRequired", value: data.podQuery.dummyOrderRequired || false, onChange: changeHandler, options: [
                            { value: true, label: "Yes" },
                            { value: false, label: "No" }
                        ] })
                    :
                        react_1.default.createElement(InfoRow_1.default, { label: "Please raise Dummy Order", value: data.podQuery.dummyOrderRequired ? "Yes" : "No" })),
            react_1.default.createElement("div", { className: "half" },
                data.status === QueriesStore_1.QueryStatus.ACTIVE &&
                    data.queryStage.stage === 2 &&
                    userStore.hasPermission(UserStore_1.Permissions.STAGE_2) ?
                    react_1.default.createElement(Radios_1.default, { altLabel: "Returns credit raised?", name: "agreeWithDiscrepancy", value: data.podQuery.agreeWithDiscrepancy || false, onChange: changeHandler, options: [
                            { value: true, label: "Yes" },
                            { value: false, label: "No" }
                        ] })
                    :
                        react_1.default.createElement(InfoRow_1.default, { label: "Returns credit raised?", value: data.podQuery.agreeWithDiscrepancy ? "Yes" : "No" }),
                data.podQuery.agreeWithDiscrepancy &&
                    react_1.default.createElement("div", { className: "hidden-inputs" },
                        data.status === QueriesStore_1.QueryStatus.ACTIVE &&
                            data.queryStage.stage === 2 &&
                            userStore.hasPermission(UserStore_1.Permissions.STAGE_2) ?
                            react_1.default.createElement(TextInput_1.default, { type: "text", name: "agreeDiscrepancyMemo", altLabel: "Returns Memo", defaultValue: data.podQuery.agreeDiscrepancyMemo || "", onKeyUp: keyHandler })
                            :
                                react_1.default.createElement(InfoRow_1.default, { label: "Returns Memo", value: data.podQuery.agreeDiscrepancyMemo || "" }),
                        data.status === QueriesStore_1.QueryStatus.ACTIVE &&
                            data.queryStage.stage === 2 &&
                            userStore.hasPermission(UserStore_1.Permissions.STAGE_2) ?
                            react_1.default.createElement(TextInput_1.default, { type: "date", name: "agreeDiscrepancyReturnsDate", altLabel: "Returns Date", value: dayjs_1.default(data.podQuery.agreeDiscrepancyReturnsDate).format("YYYY-MM-DD") || null, onChange: changeHandler })
                            :
                                react_1.default.createElement(InfoRow_1.default, { label: "Returns Date", value: dayjs_1.default(data.podQuery.agreeDiscrepancyReturnsDate).format("DD/MM/YYYY") || null })),
                data.status === QueriesStore_1.QueryStatus.ACTIVE &&
                    data.queryStage.stage === 2 &&
                    userStore.hasPermission(UserStore_1.Permissions.STAGE_2) ?
                    react_1.default.createElement(Radios_1.default, { altLabel: "Discrepancy different to query?", name: "discrepancyDifferent", value: data.podQuery.discrepancyDifferent || false, onChange: changeHandler, options: [
                            { value: true, label: "Yes" },
                            { value: false, label: "No" }
                        ] })
                    :
                        react_1.default.createElement(InfoRow_1.default, { label: "Discrepancy different to query?", value: data.podQuery.discrepancyDifferent ? "Yes" : "No" })))));
};
exports.default = PODQueryStage2;
